import React, { useMemo } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import { useAsideMenu } from "../../contexts/AsideMenuContext";

// Pages
import Dashboard from "./AppliAdmin/Dashboard/Dashboard";
import AboutAdmin from "./AppliAdmin/AboutAdmin/AboutAdmin";
import PrestationsAdmin from "./AppliAdmin/PrestationsAdmin/PrestationsAdmin";
import TestimonialsAdmin from "./AppliAdmin/TestimonialsAdmin/TestimonialsAdmin";
import NewsAdmin from "./AppliAdmin/NewsAdmin/NewsAdmin";
import AlbumsPhotos from "./AppliAdmin/AlbumsPhotos/AlbumsPhotos";
import Partenaires from "./AppliAdmin/Partenaires/Partenaires";
import Parametres from "./AppliAdmin/Parametres/Parametres";
import AbonnementParrainage from "./AppliAdmin/AbonnementParrainage/AbonnementParrainage";
import ErrorPage from "../ErrorPage/ErrorPage";
import RDVAgendaPage from "./RDVAgenda/RDVAgendaPage";

const MainContent = () => {
  const { isOpen, toggleMenu } = useAsideMenu();
  const location = useLocation();

  const pageTitle = useMemo(() => {
    const path = location.pathname;
    if (path.includes("/dashboard")) return "Tableau de bord";
    if (path.includes("/aboutme")) return "Qui suis-je ?";
    if (path.includes("/prestations")) return "Prestations";
    if (path.includes("/testimonials")) return "Témoignages";
    if (path.includes("/news")) return "Actualités";
    if (path.includes("/albums-photos")) return "Albums Photos";
    if (path.includes("/partenaires")) return "Partenaires";
    if (path.includes("/rdv-agenda")) return "RDV Agenda";
    if (path.includes("/parametres")) return "Paramètres";
    return "Back-Office";
  }, [location.pathname]);

  // Desktop left margin = sidebar width (open=72 / collapsed=20)
  // Mobile always 0, sidebar is overlay.
  const mainMargin = isOpen ? "md:ml-72" : "md:ml-20";

  return (
    <div className={`min-h-screen ml-0 ${mainMargin} transition-[margin] duration-300`}>
      {/* Header sticky */}
      <header
        className="
          sticky top-0 z-30
          border-b border-black/10 dark:border-white/10
          bg-white/70 dark:bg-slate-950/55 backdrop-blur-xl
        "
      >
        <div className="max-w-[1280px] mx-auto px-4 py-3 flex items-center justify-between gap-3">
          {/* Mobile menu button */}
          <button
            type="button"
            onClick={toggleMenu}
            className="
              md:hidden inline-flex items-center justify-center
              h-10 w-10 rounded-2xl
              bg-black/5 dark:bg-white/10
              text-slate-800 dark:text-white
              hover:bg-black/10 dark:hover:bg-white/15
              transition
              focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/60
            "
            aria-label="Ouvrir le menu"
          >
            <FiMenu className="text-xl" />
          </button>

          <div className="min-w-0">
            <div className="text-xs font-semibold text-slate-500 dark:text-slate-400">
              Administration
            </div>
            <h1 className="truncate text-lg sm:text-xl font-extrabold text-slate-900 dark:text-white">
              {pageTitle}
            </h1>
          </div>

          {/* Right slot (optionnel) */}
          <div className="hidden sm:flex items-center gap-2">
            <div className="h-10 px-4 rounded-2xl border border-black/10 dark:border-white/10 bg-white/60 dark:bg-slate-950/40 flex items-center">
              <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                Back-Office
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* Page container */}
      <main className="max-w-[1280px] mx-auto px-4 py-5">
        <div
          className="
            rounded-3xl
            border border-black/10 dark:border-white/10
            bg-white/65 dark:bg-slate-950/35
            backdrop-blur-md
            shadow-sm dark:shadow-none
            p-4 sm:p-6
          "
        >
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/aboutme" element={<AboutAdmin />} />
            <Route path="/prestations" element={<PrestationsAdmin />} />
            <Route path="/testimonials" element={<TestimonialsAdmin />} />
            <Route path="/news" element={<NewsAdmin />} />
            <Route path="/albums-photos" element={<AlbumsPhotos />} />
            <Route path="/partenaires" element={<Partenaires />} />
            <Route path="/rdv-agenda" element={<RDVAgendaPage />} />
            <Route path="/parametres" element={<Parametres />} />
            <Route path="/abonnement" element={<AbonnementParrainage />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default MainContent;
